import React from 'react';
import styled from 'styled-components';
import DOMPurify from 'dompurify';

type PreviewProps = {
  contentHTML: string;
  className?: string;
};

const RichTextPreview = styled.div`
  h1,
  p,
  ol,
  ul {
    margin-bottom: 12px;
    font-weight: 400;
    text-rendering: geometricPrecision;
  }

  h1 {
    font-size: 24px;
    line-height: 1.25;
  }

  p,
  li {
    line-height: 1.5;

    .asset-meta-container & {
      font-size: 14px;
    }
  }

  li {
    margin-left: 24px;
    margin-bottom: 4px;
  }

  ul li {
    list-style: disc;
  }

  ol li {
    list-style: decimal;
  }

  a {
    text-decoration: underline;
  }

  strong {
    font-weight: 700;
  }

  &:empty {
    display: none;
  }
`;

const Preview = ({ contentHTML, className }: PreviewProps) => (
  <RichTextPreview
    className={className}
    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(contentHTML) }}
  />
);

export default Preview;
